import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { usePrefs } from "@/contexts/PrefsContext";

export type FavKind = "venues" | "events" | "spots";

export const useFavorites = (kind: FavKind = "venues") => {
  const { user, setUser } = useAuth();
  const { t } = usePrefs();
  const navigate = useNavigate();
  const field = kind === "events" ? "fav_events" : kind === "spots" ? "fav_spots" : "favorites";
  const ids: string[] = (user && user[field]) || [];

  const toggle = async (id: string) => {
    if (!user || user.role !== "customer") {
      toast(t(kind === "events" ? "fav.loginNeededEvent" : kind === "spots" ? "fav.loginNeededSpot" : "fav.loginNeeded"));
      if (!user) navigate("/login");
      return;
    }
    const was = ids.includes(id);
    const path = kind === "events" ? `/favorites/events/${id}` : kind === "spots" ? `/me/fav-spots/${id}` : `/favorites/${id}`;
    setUser({ ...user, [field]: was ? ids.filter((x) => x !== id) : [id, ...ids] });
    try {
      const { data } = was ? await api.delete(path) : await api.post(path);
      setUser({ ...user, [field]: data[field] });
      toast.success(t(was ? "fav.removed" : "fav.added"));
    } catch (e) {
      setUser({ ...user, [field]: ids });
      toast.error(errorText(e, t));
    }
  };

  return { ids, isFav: (id: string) => ids.includes(id), toggle };
};
